import {formatDateTimeReadable} from '../../../util/formatDate';
import {DateTime} from 'luxon';
import React from 'react';
import {Box} from '@mui/material';

interface LatestTestDateProps {
    data: {
        submitted: boolean;
        finishedAt?: string;
        startedAt?: string;
    };
    useStyle: boolean;
}

const styles = {
    container: {
        fontSize: '0.8125rem',
        marginLeft: 2,
    },
};
const LatestTestDate = (props: LatestTestDateProps) => {
    if (!props.data) return null;

    const dateString = props.data.submitted ? props.data.finishedAt : props.data.startedAt;
    if (!dateString) return null;

    return (
        <Box sx={props.useStyle ? styles.container : undefined}>
            {
                (props.data.submitted ? 'abgeschlossen am ' : 'gestartet am ') +
                formatDateTimeReadable(DateTime.fromISO(dateString))
            }
        </Box>
    );
};

export default LatestTestDate;
